export default __webpack_public_path__ + "static/media/gallery_01.e3756bb2.jpg";